module.exports = __webpack_public_path__ + "static/media/overview.00a52613.jpg";